/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryMethodDto
 */
export interface DeliveryMethodDto {
    /**
     * 
     * @type {number}
     * @memberof DeliveryMethodDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryMethodDto
     */
    primaryReference?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryMethodDto
     */
    preSelected: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeliveryMethodDto
     */
    type: DeliveryMethodDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DeliveryMethodDto
     */
    feeAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryMethodDto
     */
    secondaryReferenceEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryMethodDto
     */
    tertiaryReferenceEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof DeliveryMethodDto
     */
    serviceChargeAmount?: number;
}


/**
 * @export
 */
export const DeliveryMethodDtoTypeEnum = {
    TABLE: 'TABLE',
    PICKUP: 'PICKUP',
    TAKEAWAY: 'TAKEAWAY',
    ROOM_SERVICE: 'ROOM_SERVICE',
    HOME_DELIVERY: 'HOME_DELIVERY',
    SEAT: 'SEAT',
    ROOM: 'ROOM',
    COUNTER: 'COUNTER',
    ONLINE: 'ONLINE'
} as const;
export type DeliveryMethodDtoTypeEnum = typeof DeliveryMethodDtoTypeEnum[keyof typeof DeliveryMethodDtoTypeEnum];


/**
 * Check if a given object implements the DeliveryMethodDto interface.
 */
export function instanceOfDeliveryMethodDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "preSelected" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "secondaryReferenceEnabled" in value;
    isInstance = isInstance && "tertiaryReferenceEnabled" in value;

    return isInstance;
}

export function DeliveryMethodDtoFromJSON(json: any): DeliveryMethodDto {
    return DeliveryMethodDtoFromJSONTyped(json, false);
}

export function DeliveryMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryMethodDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'primaryReference': !exists(json, 'primaryReference') ? undefined : json['primaryReference'],
        'preSelected': json['preSelected'],
        'type': json['type'],
        'feeAmount': !exists(json, 'feeAmount') ? undefined : json['feeAmount'],
        'secondaryReferenceEnabled': json['secondaryReferenceEnabled'],
        'tertiaryReferenceEnabled': json['tertiaryReferenceEnabled'],
        'serviceChargeAmount': !exists(json, 'serviceChargeAmount') ? undefined : json['serviceChargeAmount'],
    };
}

export function DeliveryMethodDtoToJSON(value?: DeliveryMethodDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'primaryReference': value.primaryReference,
        'preSelected': value.preSelected,
        'type': value.type,
        'feeAmount': value.feeAmount,
        'secondaryReferenceEnabled': value.secondaryReferenceEnabled,
        'tertiaryReferenceEnabled': value.tertiaryReferenceEnabled,
        'serviceChargeAmount': value.serviceChargeAmount,
    };
}

